import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../services/api/api.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent implements OnInit {

  constructor(private apiService: ApiService) { }

  ngOnInit(): void {
  }

  onCheckboxChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    console.log('Checked:', input.checked);
    if (input.checked) {
      this.apiService.updateUserPrivacyPolicy().subscribe(
        data => {
          if (data["d"]) {
            Swal.fire("", "האישור נקלט בהצלחה", 'success')
          }
        },
        error => {
          console.log('error onCheckboxChange:', error);
          Swal.fire("", "אירעה שגיאה בשליחת האישור, נסה שנית", 'error')

        }
      )
    }
  }

}
